export const imagebasePath = `https://raw.githubusercontent.com/javascriptkingdom/jsk-assets/ui-assets/jsk-ui`;
// export {imagebasePath}
